import { render, staticRenderFns } from "./CheckPictures.vue?vue&type=template&id=9b9bc81a&scoped=true"
import script from "./CheckPictures.vue?vue&type=script&lang=ts"
export * from "./CheckPictures.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b9bc81a",
  null
  
)

export default component.exports